import { FilterInfoSticky } from "@faire/retailer-visitor-shared/components/Filters/FilterInfoSticky";
import { FilterName } from "@faire/retailer-visitor-shared/components/Filters/FilterName";
import { PaddedContainer } from "@faire/retailer-visitor-shared/features/Marketplace/style";
import { useLoggedOutSuppliersPageMetaTagsBrandListHeader } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/LoggedOutSuppliersPageMetaTags/useLoggedOutSuppliersPageMetaTagsBrandListHeader";
import { LoggedOutSuppliersPageFilmStripBrandList } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageFilmStripBrandList/LoggedOutSuppliersPageFilmStripBrandList";
import { LoggedOutSuppliersPageFilterSidebar } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/Components/LoggedOutSuppliersPageFiltersSidebar/LoggedOutSuppliersPageFiltersSidebar";
import { LoggedOutSuppliersPageFilterStoreProvider } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/LoggedOutSuppliersPage/__internal__/LoggedOutSuppliersPageFilterStoreProvider";
import { useLoggedOutSuppliersPageUPLT } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/useLoggedOutSuppliersPageUPLT";
import { markPageJsExecuted } from "@faire/web--source/common/performance/TrackPerformanceBreakdown/markPageJsExecuted";
import { Row, Column } from "@faire/web--source/slate/Layout";
import { Spacer, getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React from "react";
import styled from "styled-components";

const PAGE_JS_EXECUTED_MARK = markPageJsExecuted();

export const LoggedOutSuppliersPageResults: React.FC<{
  scrollToBrandsSection: () => void;
}> = ({ scrollToBrandsSection }) => {
  return (
    <LoggedOutSuppliersPageFilterStoreProvider>
      <LoggedOutSuppliersPageResultsBase
        scrollToBrandsSection={scrollToBrandsSection}
      />
    </LoggedOutSuppliersPageFilterStoreProvider>
  );
};

const LoggedOutSuppliersPageResultsBase: React.FC<{
  scrollToBrandsSection: () => void;
}> = ({ scrollToBrandsSection }) => {
  const loadTimingRef = useLoggedOutSuppliersPageUPLT(PAGE_JS_EXECUTED_MARK);
  const loggedOutHeader = useLoggedOutSuppliersPageMetaTagsBrandListHeader();

  return (
    <FiltersAndResultsContainer>
      <PaddedTypography variant="displaySSerifRegular">
        {loggedOutHeader}
      </PaddedTypography>
      <Spacer height="2x" />
      <Row>
        <LoggedOutSuppliersPageFilterSidebar
          scrollToBrandsSection={scrollToBrandsSection}
        />
        <Column style={{ width: "100%" }}>
          <StyledPaddedContainer>
            <ResponsiveContentV2
              tabletAndBelow={<FilterInfoSticky name={FilterName.SUPPLIERS} />}
            />
            <div data-test-id="logged-out-suppliers-brand-list">
              <LoggedOutSuppliersPageFilmStripBrandList
                loadTimingRef={loadTimingRef}
              />
            </div>
          </StyledPaddedContainer>
        </Column>
      </Row>
    </FiltersAndResultsContainer>
  );
};

const PaddedTypography = styled(Typography)`
  ${responsiveMediaQueries.mobile} {
    padding-left: ${getSpacing("2x")};
  }
`;

const FiltersAndResultsContainer = styled(Column)`
  height: 100%;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;

  ${responsiveMediaQueries.mobile} {
    padding: 0;
  }
  ${responsiveMediaQueries.tabletAndAbove} {
    padding: ${getSpacing(0, "5x")};
  }
  ${responsiveMediaQueries.desktopAndAbove} {
    padding: ${getSpacing(0, "10x")};
  }
`;

const StyledPaddedContainer = styled(PaddedContainer)`
  ${responsiveMediaQueries.tabletAndAbove} {
    padding: 0;
  }
`;
